import React from 'react';
import { Link } from 'react-router-dom';

import PublicSiteShell from './PublicSiteShell.jsx';
import { appUrl } from '../../lib/hosts.js';

const values = [
  ['清晰', '把出口经营里真正影响利润的变量讲清楚、算清楚、留清楚。'],
  ['克制', '不把产品做成泛 CRM 或泛财务系统，先服务最关键的出口决策链路。'],
  ['落地', '尊重企业原有表格和流程，在可实施、可迁移、可复盘的基础上持续扩展。']
];

export default function About() {
  return (
    <PublicSiteShell>
      <section className="bg-[#f7f3ec]">
        <div className="mx-auto max-w-6xl px-6 py-16">
          <p className="text-sm font-semibold text-chango-700">ABOUT CHANGO</p>
          <h1 className="mt-4 max-w-3xl text-4xl font-semibold leading-tight text-slate-950 sm:text-5xl">
            长戈，专注出口企业经营决策数字化。
          </h1>
          <p className="mt-6 max-w-3xl text-lg leading-8 text-slate-700">
            长戈从出口企业的真实经营现场出发，先解决报价、成本、退税、审批和交付这些每天都在发生、又最容易影响利润的环节。我们希望系统足够专业，也足够克制，让企业不用推翻原有流程，就能逐步建立自己的出口经营底座。
          </p>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mx-auto max-w-6xl px-6">
          <div className="grid gap-5 md:grid-cols-3">
            {values.map(([title, text]) => (
              <article key={title} className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm">
                <h2 className="text-xl font-semibold text-slate-950">{title}</h2>
                <p className="mt-4 text-sm leading-7 text-slate-600">{text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="border-y border-slate-200 bg-[#fbfaf7] py-16">
        <div className="mx-auto flex max-w-6xl flex-col gap-8 px-6 md:flex-row md:items-center md:justify-between">
          <div>
            <p className="text-sm font-semibold text-amber-700">当前阶段</p>
            <h2 className="mt-3 text-3xl font-semibold text-slate-950">先把出口决策云交付扎实。</h2>
            <p className="mt-4 max-w-2xl text-sm leading-7 text-slate-600">
              当前核心产品是长戈出口决策云。工厂成本云和外贸增长云作为同一产品体系下的产品占位，会围绕真实客户场景逐步开放。
            </p>
          </div>
          <div className="flex flex-wrap gap-3">
            <a href={appUrl('/login')} className="rounded-md bg-slate-950 px-5 py-3 text-sm font-semibold text-white hover:bg-slate-800">
              进入应用
            </a>
            <Link to="/product" className="rounded-md border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-900 hover:bg-slate-50">
              查看产品体系
            </Link>
          </div>
        </div>
      </section>
    </PublicSiteShell>
  );
}
